// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e678f323","885":"a7708f90","899":"06426d11"}[chunkId] + ".chunk.js";
};